import { render, staticRenderFns } from "./place_premium_button.vue?vue&type=template&id=a6d7930c&scoped=true"
import script from "./place_premium_button.vue?vue&type=script&lang=js"
export * from "./place_premium_button.vue?vue&type=script&lang=js"
import style0 from "./place_premium_button.vue?vue&type=style&index=0&id=a6d7930c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6d7930c",
  null
  
)

export default component.exports